import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import CheckIcon from "@material-ui/icons/Check";
import ClearIcon from "@material-ui/icons/Clear";
import CircularStatic from '../common/CircularProgressWithLabel';

const useStyles = makeStyles({
  root: {
    display: "flex"
  },
  table: {
    maxWidth: '60%',
    margin: 'auto'
  },
  tableHeading: {
    backgroundColor: "#F05A29",
    borderRight: "1px solid #fbae3f",
    borderLeft: "1px solid #fbae3f",
    borderBottom: "1px solid #fbae3f",
    borderTop: "1px solid #fbae3f"
  },
  tableCell: {
    borderRight: "1px solid #fbae3f",
    borderLeft: "1px solid #fbae3f",
    borderBottom: "1px solid #fbae3f",
    borderTop: "1px solid #fbae3f"
  },
  tableContainer: {
    maxHeight: 400,
    boxShadow: 'none'
  }
});

function getCheckOrCross(checked) {
  if (checked) {
    return <CheckIcon style={{ color: "green" }}></CheckIcon>;
  } else {
    return <ClearIcon style={{ color: "#F05A29" }}></ClearIcon>;
  }
}

function createData(questionNo, correctAns, userAns, status) {
  return { questionNo, correctAns, userAns, status };
}

const rows = [
  createData("Q1", "b", "b", getCheckOrCross(false)),
  createData("Q2", "a", "c", getCheckOrCross(true)),
  createData("Q3", "c", "c", getCheckOrCross(true)),
  createData("Q4", "d", "d", getCheckOrCross(false)),
  createData("Q5", "b", "b", getCheckOrCross(false)),
  createData("Q6", "b", "b", getCheckOrCross(false)),
  createData("Q7", "b", "b", getCheckOrCross(true)),
  createData("Q8", "b", "b", getCheckOrCross(true)),
  createData("Q9", "b", "b", getCheckOrCross(false)),
  createData("Q10", "b", "b", getCheckOrCross(false)),
  createData("Q11", "b", "b", getCheckOrCross(true)),
  createData("Q12", "b", "b", getCheckOrCross(true)),
  createData("Q13", "b", "b", getCheckOrCross(false)),
  createData("Q14", "b", "b", getCheckOrCross(true)),
  createData("Q15", "b", "b", getCheckOrCross(false)),
  createData("Q16", "b", "b", getCheckOrCross(true)),
  createData("Q17", "b", "b", getCheckOrCross(false)),
  createData("Q18", "b", "b", getCheckOrCross(true)),
  createData("Q19", "b", "b", getCheckOrCross(true)),
  createData("Q20", "b", "b", getCheckOrCross(true)),
  createData("Q21", "b", "b", getCheckOrCross(false))
];

export default function ReportTable({ responses, answers, percentage}) {
  const classes = useStyles();

  var data = []

  for( var i=0; i < responses.length; i++){
    data.push(createData("Q"+`${i+1}`, answers[i], responses[i], getCheckOrCross(answers[i]===responses[i])))
  }
  

  return (
    <TableContainer component={Paper} className={classes.tableContainer}>
      <Table className={classes.table} size="small" stickyHeader aria-label="a dense table">
        <TableHead>
          <TableRow>
            <TableCell className={classes.tableHeading}>Q</TableCell>
            <TableCell className={classes.tableHeading} align="right">
              Correct Answer
            </TableCell>
            <TableCell className={classes.tableHeading} align="right">
              Your Answer
            </TableCell>
            <TableCell className={classes.tableHeading} align="right"></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row) => (
            <TableRow key={row.name}>
              <TableCell
                className={classes.tableCell}
                component="th"
                scope="row"
              >
                {row.questionNo}
              </TableCell>
              <TableCell className={classes.tableCell} align="right">
                {row.correctAns}
              </TableCell>
              <TableCell className={classes.tableCell} align="right">
                {row.userAns}
              </TableCell>
              <TableCell className={classes.tableCell} align="right">
                {row.status}
              </TableCell>
            </TableRow>
          ))}
          <TableRow>
            <TableCell colSpan={3} className={classes.tableCell} align="center">Total</TableCell>
            <TableCell className={classes.tableCell} align="right">
              <CircularStatic percentage={percentage}/>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
}